import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { GiftItemRow } from '@models/gift';
import { Link } from '@router/Link';
import { hexToRgba } from '@utils/colorUtils';

interface Props {
    giftItem: GiftItemRow;
}

function GiftItem({ giftItem }:Props) {
  const {
    name, salePrice, imageUrl, id, status,
  } = giftItem;
  return (
        <Link style={{ width: '100%' }}
              activityParams={{ giftItemId: id }}
              activityName='GiftItemActivity' >
            <Column align='center' fullWidth>
                <ImageWrapper>
                    <Image src={imageUrl}
                           width={120}
                           height={120}
                           alt='상품' />
                    {status === 'SOLD_OUT' && (
                        <SoldOut>
                            <Text color={colors.gray7}
                                  fontWeight='bold' >
                                SOLDOUT
                            </Text>
                        </SoldOut>
                    )}
                </ImageWrapper>
                <Text >{name}</Text>
                <Text size='lg' fontWeight='bold'>
                    {salePrice.toLocaleString()}원
                </Text>
            </Column>
        </Link>
  );
}

const ImageWrapper = styled.div`
    align-items: center;
    aspect-ratio: 1;
    border-radius: 12px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.10);
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
    width: 100%;
    position: relative;
`;

const SoldOut = styled.div`
    position: absolute;
    width: 88px;
    height: 24px;
    display:flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.primaryOpacity65};
    transform: rotate(-18deg);
`;

export default GiftItem;
